<template>
  <v-list class="pt-20 text-left mh100">
    <h2 class="ml-3">Porichoy NID Data</h2>
    <v-divider></v-divider>
    <br />
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>NID :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.nid || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-layout row wrap>
      <v-flex sm12 class="divWidthHeight mt100">
        <v-list-tile>
          <v-flex sm4>
            <h5>NID Photo :</h5>
          </v-flex>
          <v-flex sm8>
            <a
              v-if="userData.nid_photo"
              :href="`${nid_Url}/${userData.nid_photo}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ImgLazyLoad
                class="imageHeightWidth"
                :src="`${nid_Url}/${userData.nid_photo}`"
              />
            </a>
            <v-list-tile-content v-else>Not uploaded</v-list-tile-content>
          </v-flex>
        </v-list-tile>
      </v-flex>
    </v-layout>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Name (Bangla) :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.name_bn || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Name (English) :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.name_en || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Father's Name (Bangla) :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.father_bn || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Father's Name (English) :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.father_en || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Mother's Name (Bangla) :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.mother_bn || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Mother's Name (English) :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.mother_en || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Spouse's Name (Bangla) :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.spouse_bn || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Spouse's Name (English) :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.spouse_en || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Gender :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.gender || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Date of Birth :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.dob || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Permanent Address (Bangla) :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.permanent_address_bn || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Permanent Address (English) :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.permanent_address_en || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>

    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>API Verified :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content
            v-if="userData.api_verified"
            style="color: green"
          >
            Yes
          </v-list-tile-content>
          <v-list-tile-content v-else style="color: red">
            No
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
  </v-list>
</template>
<script>
  import ImgLazyLoad from "@/components/ImgLazyLoad";
  export default {
    components: { ImgLazyLoad },
    props: ["userData"],
    data() {
      return {
        nid_Url: process.env.VUE_APP_NID_URL,
      };
    },
  };
</script>
<style scoped>
  .divWidthHeight {
    width: 200px;
    height: 200px;
  }
  .imageHeightWidth {
    max-width: 200px;
    height: auto;
    max-height: 200px;
  }
  .mt100 {
    margin-top: 100px;
  }
</style>
